import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const STYLES = {
  green: { bg: '#dcfce7', fg: '#15803d', dot: '#22c55e', label: 'Healthy' },
  amber: { bg: '#fef3c7', fg: '#b45309', dot: '#f59e0b', label: 'Stale' },
  red:   { bg: '#fee2e2', fg: '#b91c1c', dot: '#ef4444', label: 'Not updating' },
  checking: { bg: '#f1f5f9', fg: '#64748b', dot: '#94a3b8', label: 'Checking feed…' },
};

const ageText = (h) => {
  if (!h.reachable) return 'feed unreachable';
  if (h.age_days == null) return 'no activity found';
  if (h.age_days < 1) return `last activity ${Math.max(1, Math.round(h.age_days * 24))}h ago`;
  return `last activity ${Math.round(h.age_days)}d ago`;
};

export function FeedHealthBadge({ consumer, kind }) {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setHealth(null);
    axios.get(`${API}/api/feeds/${consumer}/${kind}/health`, { withCredentials: true })
      .then(r => !cancelled && setHealth(r.data))
      .catch(() => !cancelled && setHealth({ status: 'red', reachable: false }));
    return () => { cancelled = true; };
  }, [consumer, kind]);

  const st = STYLES[health?.status || 'checking'];
  const tip = health?.latest_activity ? `Newest enrollment/completion in feed: ${health.latest_activity} UTC` : health?.error || '';
  return (
    <span data-testid="feed-health-badge" data-status={health?.status || 'checking'} title={tip}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '4px 12px', borderRadius: 999, background: st.bg, color: st.fg, fontSize: 12, fontWeight: 600, transition: 'background-color .2s' }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: st.dot, boxShadow: `0 0 0 3px ${st.dot}33` }} />
      {st.label}{health && <span data-testid="feed-health-age" style={{ fontWeight: 500 }}>· {ageText(health)}</span>}
    </span>
  );
}
